<template>
  <ul
    class="flex flex-wrap text-sm text-semantic-surface-on-surface-variant text-semantic-sizing-label-lg"
    :data-testid="dataTestid"
  >
    <!-- eslint-disable vue/no-v-html -->
    <li
      v-for="(page, index) in pages"
      :key="index"
      class="flex items-center"
      :class="{
        'flex-1 truncate max-w-[15.75rem]': index === pages.length - 1,
      }"
    >
      <div
        v-if="!page.active && page.url"
        class="flex items-center"
      >
        <NuxtLink
          :to="page.url"
          class="leading-[100%]"
          :class="{
            'hover:underline': page.url,
          }"
        >
          {{ removeHtmlString(page.text) }}
        </NuxtLink>

        <V2IconsCaret
          direction="right"
          :fill="caretColor"
          class="mx-2 md:mx-4 wh-4"
          :class="caretClass"
        />
      </div>

      <span
        v-else-if="!page.active && !page.url"
        class="flex items-center truncate w-full leading-[100%]"
        :class="{
          'hover:underline': page.url,
        }"
      >
        {{ removeHtmlString(page.text) }}

        <V2IconsCaret
          direction="right"
          :fill="caretColor"
          class="mx-2 md:mx-4 wh-4"
          :class="caretClass"
        />
      </span>

      <span
        v-else
        class="font-bold text-semantic-primary-default align-middle w-full truncate"
        :class="page.activeClass"
        v-html="removeHtmlString(page.text)"
      />
    </li>
  </ul>
</template>

<script setup>
import { arrayObjectPropValidator } from '~/helpers/validator'

defineOptions({
  name: 'V2MoleculesBreadCrumb'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: 'breadcrumb'
  },

  pages: {
    type: Array,
    default: () => [
      {
        text: 'Label',
        url: '/',
        active: false
      }
    ],
    validator: value => {
      return arrayObjectPropValidator(value, ['text'])
    }
  },

  hasJsonSchema: {
    type: Boolean,
    default: false
  },

  caretClass: {
    type: String,
    default: ''
  }
})

const caretColor = computed(() =>
  semanticColorLookup('surface.on-surface-variant')
)

useJsonld(() => {
  if (!props.hasJsonSchema) {
    return null
  }

  return GENERATE_BREADCRUMB_SCHEMA(props.pages)
})
</script>
